import { FARM_INFORMATION } from "./action";

const initialState = {
  destinationsList: []
};
export const FarmInformationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FARM_INFORMATION.getAllDestinationsList.success:
      return {
        ...state,
        destinationsList: action.data
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/farmInformation/reducer.js